import { useState, useEffect } from "react";

const DEFAULT_ACKNOWLEDGMENTS = [
  {
    text: "I acknowledge that I am the owner or authorized representative of this business and have the authority to claim this business.",
    required: false,
    registration: false,
    newBusiness: true,
    dnd: {
      email: false,
      sms: false,
      call: false,
    },
    tag: "",
  },
  {
    text: "I consent to receive marketing and informational text messages and automated or prerecorded voice calls (including AI-assisted calls) from this business. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Text STOP to unsubscribe from text messages at any time.",
    required: true,
    registration: true,
    newBusiness: true,
    dnd: {
      email: false,
      sms: true,
      call: false,
    },
    tag: "optin_voiceaicalls",
  },
];

const useAcknowledgments = (inputData) => {
  const [acknowledgments, setAcknowledgments] = useState(DEFAULT_ACKNOWLEDGMENTS);

  useEffect(() => {
    if (inputData?.acknowledgments && inputData.acknowledgments.length > 0) {
      setAcknowledgments(inputData.acknowledgments);
    } else {
      setAcknowledgments([
        {
          text: "I acknowledge that I am the owner or authorized representative of this business and have the authority to claim this business.",
          required: true,
          registration: false,
          newBusiness: true,
          dnd: {
            email: false,
            sms: false,
            call: false,
          },
          tag: "",
        },
        {
          text: "I consent to receive marketing and informational text messages and automated or prerecorded voice calls (including AI-assisted calls) from this business. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Text STOP to unsubscribe from text messages at any time.",
          required: false,
          registration: true,
          newBusiness: true,
          dnd: {
            email: false,
            sms: true,
            call: false,
          },
          tag: "optin_voiceaicalls",
        },
      ]);
    }
  }, [inputData]);

  const handleChange = (index, field, value) => {
    const updated = [...acknowledgments];
    updated[index][field] = value;
    setAcknowledgments(updated);
  };
  // const handleChangeDnD = (index, field, value) => {
  //   const updated = [...acknowledgments];
  //   updated[index][field] = value;
  //   setAcknowledgments(updated);
  // };

  const handleChangeDnD = (index, type, value) => {
  const updated = [...acknowledgments];

  updated[index] = {
    ...updated[index],
    dnd: {
      ...updated[index].dnd,
      [type]: value,
    },
  };

  setAcknowledgments(updated);
};

  const handleAdd = () => {
    setAcknowledgments([
      ...acknowledgments,
      {
        text: "I acknowledge that I am the owner or authorized representative of this business and have the authority to claim this business.",
        required: false,
        registration: false,
        newBusiness: false,
        dnd: {
          email: false,
          sms: false,
          call: false,
        },
        tag: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    const updated = acknowledgments.filter((_, i) => i !== index);
    setAcknowledgments(updated);
  };

  return {
    acknowledgments,
    handleChange,
    handleChangeDnD,
    handleAdd,
    handleRemove,
  };
};

export default useAcknowledgments;
